/* eslint-disable camelcase */
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import {
  Row,
  Column,
  Container,
  Loader,
  Heading,
  Details,
  DetailsHeaderItem,
  withApi,
  withUser,
  withBrowser,
  withAccessRights,
  apiShape,
  ActionBar,
  intlShape,
  browserShape,
  withNotifier,
  notifierShape,
  NotFoundError,
  formatDateTime,
} from "lcm-iot-commons";
import {
  getUpdateScheduleStatusIcon,
  renameDownloadingStatus,
} from "../../utils/edgeDeviceUpdateSchedulesUtils";

type Props = {
  api: apiShape;
  intl: intlShape;
  browser: browserShape;
  notifier: notifierShape;
  match: {
    params?: {
      id?: string;
      updateSchedulesId?: string;
    };
  };
};

export function UpdateSchedulesDetails(props: Props) {
  const { api, browser, match, intl, notifier } = props;
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{ id?: strin... Remove this comment to see the full error message
  const { id, updateSchedulesId } = match.params;
  const [detailsObject, setDetailsObject] = useState(null);

  const loadData = async () => {
    try {
      let response = await api.get(
        `/edm/update_schedules/${updateSchedulesId}`,
        { include: "software_version, status" },
        false,
      );
      if (response?.status?.code?.includes("downloading"))
        response = renameDownloadingStatus(response);
      setDetailsObject({ ...response });
    } catch (error) {
      if (error instanceof NotFoundError) {
        browser.navigateTo("/404");
      } else {
        notifier.showError(api.translateError(error));
        setDetailsObject(null);
      }
    }
  };
  React.useEffect(() => {
    loadData();
  }, [id]);

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading
              id="update-schedules-details-header"
              title={intl.formatMessage({
                id: "update_schedules.details.header",
              })}
            />
          </ActionBar>
          {detailsObject && (
            <Details>
              <DetailsHeaderItem
                id="update-schedules-details-software-version"
                translationKey="update_schedules.details.software_version"
                value={
                  (detailsObject as $TSFixMe)?.software_version?.version_name
                }
              />
              <DetailsHeaderItem
                id="update-schedules-details-status"
                icon={`update-schedules-icon ${getUpdateScheduleStatusIcon((detailsObject as $TSFixMe)?.status?.code)}`}
                translationKey="update_schedules.details.status"
                value={(detailsObject as $TSFixMe)?.status?.name}
              />
              <DetailsHeaderItem
                id="update-schedules-details-updated-at"
                translationKey="update_schedules.details.updated_at"
                value={
                  (detailsObject as $TSFixMe)?.updated_at
                    ? formatDateTime(
                        (detailsObject as $TSFixMe)?.updated_at,
                        intl,
                      )
                    : "-"
                }
              />
            </Details>
          )}
          <Loader id="loader" loading={!detailsObject} />
        </Column>
      </Row>
    </Container>
  );
}

export default withBrowser(
  withNotifier(
    withApi(
      withUser(
        // @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
        injectIntl(withAccessRights(UpdateSchedulesDetails, "EDM::EdgeDevice")),
      ),
    ),
  ),
);
